// extracted by mini-css-extract-plugin
export default {"card":"AppointmentFullInfoCard_card__VjFwO","grid":"AppointmentFullInfoCard_grid__NFITe","info":"AppointmentFullInfoCard_info__dMlhH"};